import React, { Component, Fragment } from 'react';
import { ACCESS_TOKEN, API_BASE_URL } from "../../constatns";
import TournamentItem from "./TournamentItem";
import noProfile from "../../assets/img/no-profile.png";
import { RiBarChartBoxLine } from "react-icons/ri";
import no1 from "../../assets/img/tournament/icoRank1.png";
import no2 from "../../assets/img/tournament/icoRank2.png";
import no3 from "../../assets/img/tournament/icoRank3.png";
import moment from "moment";
import Button from "react-bootstrap/Button";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import CardHeader from "@material-ui/core/CardHeader";
import Card from "@material-ui/core/Card";
import Avatar from "@material-ui/core/Avatar";
import Link from "react-router-dom/Link";

class TournamentDetailHome extends Component {

	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {

		fetch(`${API_BASE_URL}/tournament/catches?tournamentId=${this.props.data.id}`, {
			method: 'GET',
		}).then(res => res.text())
		.then(body => {
			let result = JSON.parse(body);
			this.setState({result: result.datas});
			if (!result.datas) return;

			const items = result.datas.map((item, index) => {

				const length = Math.floor(item.length * 10)/10;
				const weight = Math.floor(item.weight/1000 * 100) /100;
				const catchDT = moment(new Date(1 * (item.catch_date))).format('YYYY-MM-DD HH:mm');

				return (
					<Link to={{
						pathname: '/catches/'+item.id,
						state: item
					}} key={item.id}>
						<Card style={{maxWidth: '345px', minWidth: '345px', marginBottom: '10px', marginRight: '8px'}}>
							<CardHeader
								avatar={
									<Avatar aria-label="recipe" src={item.angler.image_url}></Avatar>
								}
								title={item.angler.username}
								subheader={catchDT}
							/>
							<CardMedia style={{
								height: 0,
								paddingTop: '56.25%', // 16:9
							}}
								image={item.img}
								title="Paella dish"
							/>
							<CardContent>
								<Typography variant="body1" color="textSecondary" component="p">
									{length} cm / {weight} kg
								</Typography>
							</CardContent>
						</Card>
					</Link>
				)
			});

			this.setState({items: items});
		});

		fetch(`${API_BASE_URL}/tournament/best?tournamentId=${this.props.data.id}`, {
			method: 'GET',
		}).then(res => res.text())
		.then(body => {
			let result = JSON.parse(body);
			if (!result.bestAngler) return;

			const best = result.bestAngler.map((item, index) => {

				const ribbonColor = index === 0 ? 'ribbon-danger' : index === 1 ? 'ribbon-warning' : 'ribbon-info';
				const award = index == 0 ?
					<img src={no1} style={{position: 'absolute', zIndex: 999, top: '0px', left: '10px'}}/>
					: index == 1 ? <img src={no2} style={{position: 'absolute', zIndex: 999, top: '0px', left: '10px'}}/>
						: index == 2 ? <img src={no3} style={{position: 'absolute', zIndex: 999, top: '0px', left: '10px'}}/>
							: '';
				return (
					<div className="col-md-3 col-xs-12 card pd-10 mr-20 " key={index}>
						{award}
						<div className="card-body" style={{textAlign: 'center'}}>
							<img src={item.image_url ? item.image_url : noProfile} style={{width: '135px', height: '135px', borderRadius: '50%'}}></img>
							<div className={'text-center mt-10'}>
								{item.username}
								<div>{item.amount.toFixed(2)} <b>P</b></div>
							</div>
						</div>

					</div>
				)
			});

			this.setState({best: best});
		});

	}

	makeStyles = (theme) => ({
		root: {
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'space-around',
			overflow: 'hidden',
			backgroundColor: '#fff',
		},
		gridList: {
			width: 500,
			height: 450,
		},
		icon: {
			color: 'rgba(255, 255, 255, 0.54)',
		},
	});

	render() {

		const classes = this.makeStyles();

		const handleJoin = (e) => {
			if (localStorage.getItem(ACCESS_TOKEN)) {

			} else {
				alert('로그인 후 참가하실 수 있습니다.');
			}
		};

		const startDT = moment(new Date(1 * (this.props.data.tournament_period.start))).format('YYYY-MM-DD HH:mm');
		const endDT = moment(new Date(1 * (this.props.data.tournament_period.end))).format('YYYY-MM-DD HH:mm');
		const memCnt = (this.props.data.participants) ? (this.props.data.participants.length) : 0;
		let fish = "";
		if (this.props.data.fish) {
			if (this.props.data.fish.length === 0) {
				fish = "any";
			} else {
				for (let i = 0; i < this.props.data.fish.length; i++) {
					fish += this.props.data.fish[i].name_kr;
					if (i !== this.props.data.fish.length - 1) fish += ", ";
				}
			}
		} else {
			fish = "any";
		}
		return (
			<Fragment>
				<div className="row">
					<div className="col-xl-3 xl-40 col-lg-12 col-md-5">
						<div className="default-according style-1 faq-accordion job-accordion" id="accordionoc4">
							<div className="row">
								<div className="col-sm-12">
									<div className="card pd-10">
										<div className="card-header">
											<div className={'row'}>
												<img className={'avata'} src={this.props.data.owner[0].image_url ? this.props.data.owner[0].image_url : noProfile}
														 style={{width: '60px', height: '60px', borderRadius: '50%'}}/>
												<div className="h5 mb-0"
														 style={{lineHeight: '52px', marginLeft: '8px'}}>{this.props.data.owner[0].username}</div>
											</div>
										</div>
										<div className="card-body pd-10">
											<TournamentItem
												isDetail={true}
												key={this.props.data.id}
												id={this.props.data.id}
												title={this.props.data.title}
												owner={this.props.data.owner[0].username}
												date={startDT +' ~ '+ endDT}
												tn_type={this.props.data.tn_type}
												tn_fish={fish}
												tn_members={memCnt}
												status={this.props.data.status}
												catchCount={this.props.data.catchCount}
											/>
											<Button variant="warning" block><RiBarChartBoxLine/> LIVE SCORE </Button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-9 xl-60 col-lg-12 col-md-7">
						<div className="row">
							<div className="col-xl-12">
								<h5 className="mb-0">
									Best Ranking
								</h5>
								<div className="row catches">
									{this.state.best}
								</div>
							</div>
						</div>

						<div className="row pt-30">
							<div className="col-xl-12">
								<h5 className="mb-0">
									BrowseAll
								</h5>
								<div className={classes.root + ' row catches'} >
									{this.state.items}
								</div>
							</div>
						</div>

					</div>
				</div>
			</Fragment>
		);
	}
}

export default TournamentDetailHome;
